import React from 'react';
import styled from 'styled-components';
import { CONTAINER } from '../Colors';

const StyledDiv = styled.div`
    width: 100%;
    min-height: 100%;
    background-color: ${CONTAINER};
`

interface TabProps {
    tabKey: string,
    label: string,
    disabled?: boolean,
}

export const Tab: React.FunctionComponent<TabProps> = (props) => {
    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    return (
        <StyledDiv className={`${stylingClassName}`}>
            {props.children}
        </StyledDiv>
    );
}